module.exports = __webpack_public_path__ + "img/square-font-awesome.d98a8015.svg";